<template>
    <div>
        <el-dialog title="签署-居间服务合同" :visible.sync="signDialog" width="1000px" :close-on-click-modal="false" center>

            <el-form :inline="true" ref="signForm" label-width="100px">
                <el-row align="center" style="font-size:16px;">
                    <el-col :span="2">&nbsp;</el-col>
                    <el-col :span="7">服务者姓名：{{tempRow.workerName}}</el-col>
                    <el-col :span="7">电话：{{tempRow.workerTel}}</el-col>
                    <el-col :span="6">身份证：{{tempRow.workerIdcard}}</el-col>
                </el-row>
                <br />

                <template v-for="(item,index) in signFieldList">
                    <el-form-item :label="item.fieldName" :key="index" v-if="checkShow(item)">
                        <el-radio v-if="item.signAccountType=='workerIdCardType'||item.signAccountType=='customerIdCardType'" @click.native.prevent="clearClick(item)" v-model="item.fieldValue" :label="item.myextJsonList[0].dictVal"></el-radio>

                        <el-select v-else-if="item.type==30" v-model="item.fieldValue" clearable :placeholder="'请选择'+item.fieldName">
                            <el-option v-for="(item,index) in item.myextJsonList" :key="index" :label="item.dictKey" :value="item.dictVal"></el-option>
                        </el-select> 
                        <el-input v-else v-model="item.fieldValue" :placeholder="'请输入'+item.fieldName" clearable></el-input>
                    </el-form-item>

                    <el-form-item label-width="50px"  :label="item.fieldName" :key="index" v-if="item.type==34||item.type==35||item.type==36">
                        <el-date-picker style="width:110px;" v-if="item.type==34" v-model="item.fieldValue" type="year" value-format="yyyy" format="yyyy年" placeholder="选择年" class="year">
                        </el-date-picker>   
                        <el-date-picker style="width:110px;" v-else-if="item.type==35" v-model="item.fieldValue" type="month" value-format="MM"  format="MM月" placeholder="月" class="mon">
                        </el-date-picker>
                        <el-date-picker style="width:110px;" v-else-if="item.type==36" v-model="item.fieldValue" type="date" value-format="dd"  format="dd日" placeholder="日" class="day">
                        </el-date-picker>
                    </el-form-item>
                </template>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="signDialog=false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>

        </el-dialog>
    </div>
</template>
<script>
//servantRecommend
import "@/components/workercrm/css/index.css";
import workercrmapi from "@/script/api/workercrmapi";
import moment from "moment";
import {
    validatePhoneTwo,
    validateIdNo,
    validateIdNoOrNull,
    validateNumber,
} from "@/script/validator";
import globalData from "@/components/common/globaldata/global.data.vue";
import ajaxStorage from "@/script/api/storage.js";
import lrz from "lrz";
export default {
    data() {
        return {
            templateId: null,
            signFieldList: [],
            signFieldArr: {},
            signDialog: false,
            tempRow: {},
        };
    },

    methods: {
        yulan() {
            console.log(globalData.franchisee.id);
            let req = {
                templateId: this.templateId,
                sysType: "worker_crm",
                relationNo: this.tempRow.id,
                storeId: globalData.franchisee.id,
                fieldList: this.signFieldList,
            };
            
            req.fieldList.forEach(e=>{
                e.myextJsonList=[];
            })

            workercrmapi.$axiosFillContractTemplate(req).then((res) => {
                if (res.data.errno == 0) {
                 window.open( res.data.data.downloadUrl);
                }
            });
        },
        clickSign(row) {
            this.tempRow = row;
            this.signDialog = true;
            workercrmapi.$axiosGetContractSignField({ type: 1 }).then((res) => {
                if (res.data.errno == 0) {
                    this.signFieldList = res.data.data.fieldList;
                    this.templateId = res.data.data.templateId;
                } else {
                    this.$message.warning(res.data.errmsg);
                }
            });
        },
        checkShow(item) {
            if (!(item.fieldBuzKey == "" || item.fieldBuzKey == null)) {
                return false;
            }
            //`type` int DEFAULT NULL COMMENT '填写控件类型:1-单行文本，2-数字，3-日期，6-签约区,8-多行文本，11-图
            // 20合同编号 30下拉选择，31复选框，32身份证，33手机号，34年，35月，36日,37默认年月日',

            if (item.type == 6 || item.type == 20 || item.type == 37) {
                return false;
            }

            if (item.type == 34 || item.type == 35 || item.type == 36) {
                return false;
            }


            return true;
        },
        clearClick(item) {
            console.log(item);
            if (item.fieldValue == "" || item.fieldValue == null) {
                item.fieldValue = item.myextJsonList[0].dictVal;
            } else {
                item.fieldValue = "";
            }
        },
    },
};
</script>
<style scoped>
</style>
